// extracted by mini-css-extract-plugin
module.exports = {"bidAmount":"UnderOffer_bidAmount__Zpp2s","highestBidContainer":"UnderOffer_highestBidContainer__7P6Yg"};